import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
import { MovieIcon } from '../../atoms/icons/movie_icon';
import { SeriesIcon } from '../../atoms/icons/series_icon';
import { PlaylistIcon } from '../../atoms/icons/playlist_icon';
import { SearchContentCategories } from './search_filter_state';
const categoryIcon = (category) => {
    if (category === 'lesson')
        return React.createElement(MovieIcon, { color: Colors.PrimaryDark });
    if (category === 'series')
        return React.createElement(SeriesIcon, { color: Colors.PrimaryDark });
    return React.createElement(PlaylistIcon, { color: Colors.PrimaryDark });
};
export const SearchFilterProgram = ({ category, onSelect }) => {
    const items = SearchContentCategories.map((item, index) => (Object.assign(Object.assign({}, item), { selected: category === item.value, hasGap: index < SearchContentCategories.length - 1, icon: categoryIcon(item.value) })));
    return (React.createElement("div", { className: css(styles.row) }, items.map((item) => (React.createElement("div", { key: item.value, className: css(styles.card, item.hasGap && styles.cardGap, item.selected && styles.cardOn), onClick: () => onSelect(item.value) },
        item.icon,
        React.createElement("span", null, item.label))))));
};
const styles = StyleSheet.create({
    row: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    card: {
        flex: 1,
        minWidth: 0,
        cursor: 'pointer',
        backgroundColor: Colors.White,
        border: `1.5px solid ${Colors.BorderLightGray}`,
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px 0',
        fontSize: 14,
        lineHeight: '140%',
        gap: 2,
    },
    cardGap: {
        marginRight: 8,
    },
    cardOn: {
        borderColor: Colors.PrimaryDark,
        backgroundColor: Colors.PrimaryLighter,
    },
});
